<template>
  <div class="con-wrap full-page" style="background-color: #fff">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="orderNum">
          <el-input
            v-model="queryForm.orderNum"
            @keyup.enter.native="query"
            placeholder="工单编号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="stationName">
          <el-input
            v-model="queryForm.stationName"
            @keyup.enter.native="query"
            placeholder="站址名称"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="name">
          <el-input
            v-model="queryForm.name"
            @keyup.enter.native="query"
            placeholder="接单人员"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="plate">
          <el-input
            v-model.trim="queryForm.plate"
            @keyup.enter.native="query"
            placeholder="车牌号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="time">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="queryForm.time"
            type="date"
            placeholder="派单日期"
          ></el-date-picker>
        </el-form-item>
        <el-button
          v-if="hasPerm('order:manage:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('order:manage:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          v-if="hasPerm('order:manage:save')"
          type="primary"
          @click="addOrder"
          >新增</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('order:manage:delete')"
          type="danger"
          @click.native="delOrder"
          >删除</el-button
        >
        <el-button
          v-if="hasPerm('order:manage:transfer')"
          type="primary"
          @click="transferOrder"
          >转单</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="45"></el-table-column>
      <el-table-column
        prop="subjectNum"
        label="工单编号"
        width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="type" label="工单类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">计划发电</span>
          <span v-else-if="scope.row.type == 2">应急发电</span>
        </template>
        <template slot="header">
          <span>工单类型</span>
          <span @click="typeChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="stationName"
        label="站址名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="dispatchName" label="派单人员"></el-table-column>
      <el-table-column
        prop="dispatchTime"
        label="派单时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiveName"
        label="接单人员"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="plateNumList" label="车牌号" min-width="100">
        <template slot-scope="{ row }">
          <el-tooltip placement="top" :disabled="row.plateNumList.length <= 1">
            <div slot="content" v-if="row.plateNumList.length > 1">
              <span v-for="(item, index) in row.plateNumList" :key="index">{{
                item + "," + " "
              }}</span>
            </div>
            <span v-if="row.plateNumList.length > 1" class="modify">
              <el-select v-model="plateNum">
                <el-option
                  v-for="(item, index) in row.plateNumList"
                  :key="index + item"
                  :label="item"
                  :value="index"
                  @click.native="gotoMonitor(item)"
                ></el-option>
              </el-select>
            </span>
            <span
              v-else
              style="cursor: pointer; color: #0094ff"
              @click="gotoMonitor(row.plateNumList[0])"
              >{{ row.plateNumList[0] }}</span
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="vin"
        label="车架号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiveTime"
        label="接单时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="takeTime"
        label="工单历时"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="receiveState" label="工单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.receiveState == 1" class="btn-gray"
            >待接单</span
          >
          <span v-else-if="scope.row.receiveState == 2" class="btn-green"
            >已接单</span
          >
          <span v-else-if="scope.row.receiveState == 4" class="btn-blue"
            >转单中</span
          >
          <span v-else></span>
        </template>
        <template slot="header">
          <span>工单状态</span>
          <span @click="receiveChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column prop="businessType" label="工单业务类型" min-width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.businessType == 1">基站</span>
          <span v-else-if="scope.row.businessType == 2">银行</span>
          <span v-else></span>
        </template>
        <template slot="header">
          <span>工单业务类型</span>
          <span @click="businessChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('order:manage:info')"
            @click.stop="getOrderInfo(scope.row)"
            >详情</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('order:manage:scene:task')"
            @click.stop="getpic(scope.row)"
            >现场照片</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 详情弹窗 -->
    <el-dialog
      title="详情"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
    >
      <div class="con-left">
        <p class="dialog-title">工单信息</p>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单编号</el-col>
          <el-col :span="18">{{
            $judgeEmpty(detailsInfoData.subjectNum)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单类型</el-col>
          <el-col :span="18">{{ $judgeEmpty(detailsInfoData.type) }}</el-col>
        </el-row>
        <el-row :gutter="20" v-if="detailsInfoData.type === '计划发电'">
          <el-col :span="6" class="dialog-label">停电时间</el-col>
          <el-col
            :span="18"
            v-if="detailsInfoData.startTime || detailsInfoData.endTime"
          >
            {{ $judgeEmpty(detailsInfoData.startTime) }}至
            <br />
            {{ $judgeEmpty(detailsInfoData.endTime) }}
          </el-col>
          <el-row v-else>-</el-row>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单状态</el-col>
          <el-col :span="18">{{
            $judgeEmpty(detailsInfoData.receiveState)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">工单内容</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.content)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.content) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">派单人员</el-col>
          <el-col :span="18">{{
            $judgeEmpty(detailsInfoData.dispatchName)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">接单人员</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.receiveName)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.receiveName) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">联系电话</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.phone)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.phone) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">车架号</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.vin)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.vin) }}</el-col
          >
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">车牌号</el-col>
          <el-col
            :span="18"
            :title="$judgeEmpty(detailsInfoData.platNum)"
            class="text-overflow"
            >{{ $judgeEmpty(detailsInfoData.platNum) }}</el-col
          >
        </el-row>
      </div>
      <div class="con-right">
        <p class="dialog-title">站址信息</p>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">站址名称</el-col>
          <el-col :span="18">{{
            $judgeEmpty(stationInfoData.stationName)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">站址编码</el-col>
          <el-col :span="18">{{ $judgeEmpty(stationInfoData.code) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">经度</el-col>
          <el-col :span="18">{{
            $judgeEmpty(stationInfoData.longitude)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">纬度</el-col>
          <el-col :span="18">{{
            $judgeEmpty(stationInfoData.latitude)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">基站直流负载（A）</el-col>
          <el-col :span="18">{{
            $judgeEmpty(stationInfoData.dcLoadCurrent)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">详细地址</el-col>
          <el-col :span="18">{{ $judgeEmpty(stationInfoData.addr) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">备注</el-col>
          <el-col :span="18">{{ $judgeEmpty(stationInfoData.remark) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6" class="dialog-label">归属分组</el-col>
          <el-col :span="18">{{
            $judgeEmpty(stationInfoData.areaName)
          }}</el-col>
        </el-row>
      </div>
      <div>
        <p class="dialog-title">工单进度</p>
        <div class="time-wrap">
          <span class="time-box">
            <span class="time-label">计时</span>
            <span class="time-con">{{
              $judgeEmpty(infoData.totalTakeTime)
            }}</span>
          </span>
        </div>
        <order-step :orderInfoData="orderInfoData" :step="step"></order-step>
      </div>
    </el-dialog>
    <el-dialog
      title="现场照片"
      :visible.sync="picVisible"
      class="examine-dialog"
    >
      <div
        class="examine-box"
        v-for="(item, index) in scenePhotos"
        :key="index"
      >
        <p class="dialog-title">
          <span>{{ $judgeEmpty(item.personnelName) }}</span
          ><span>({{ $judgeEmpty(item.plateNum) }})</span>
        </p>
        <div class="image-box" v-if="item.urls.length != 0">
          <el-image
            style="width: 100px; height: 100px; margin-right: 10px"
            v-for="url in item.urls"
            :key="url"
            :src="url"
            :zIndex="3000"
            :preview-src-list="item.urls"
            @click.stop="handleClickItem"
          >
          </el-image>
        </div>
        <div v-else style="padding-left: 20px">未上传现场照片</div>
      </div>
      <div v-if="picFlag" class="textBox">
        <p>暂未上传照片</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderStep from "../../../components/OrderStep.vue";
export default {
  components: {
    OrderStep,
  },
  data() {
    return {
      plateNum: 0,
      queryForm: {
        orderNum: "",
        stationName: "",
        name: "",
        plate: "",
        time: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      // tableHeight: 0,
      tableData: [],
      tableVal: [],
      infoData: {},
      orderInfoData: [],
      detailsInfoData: {},
      stationInfoData: {},
      infoVisible: false,
      orderType: "",
      receive: "",
      businessType: "",
      step: [],
      scenePhotos: [],
      picVisible: false,
      picFlag: false,
    };
  },
  // beforeRouteLeave (to, from, next) {
  //   // ...跳转切换，离开当前页面
  //   console.log(to, from, next);
  // },
  created() {
    this.receive = this.$route.params.id;
  },
  mounted() {
    /** 
      1、resetFields()方法用于将form表单的数据设置为初始值
      2、而这个初始值是在form mounted生命周期被赋值上去的
      3、所以，在 form mounted之前，如果给form表单赋值了，那么后面调用resetFields()都是无效的，因为form表单的初始值已经在 mounted 之前就被赋值了
    */
    if (this.$route.params.dispatchPlateNum) {
      this.queryForm.plate = this.$route.params.dispatchPlateNum;
    }
    this.getOrderList();
  },
  methods: {
    // ??? 跳转至运行监控
    gotoMonitor(plate) {
      console.log(plate);
      sessionStorage.setItem("fullMonitorPlate", plate);
      sessionStorage.setItem("isSearch", true);
      const { href } = this.$router.resolve({
        path: "/fullScreenMonitor",
      });
      window.open(href, "_blank");
    },
    async getOrderList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        receiveState: this.receive,
        subjectNum: this.queryForm.orderNum,
        stationName: this.queryForm.stationName,
        name: this.queryForm.name,
        plate: this.queryForm.plate,
        time: this.queryForm.time,
        type: this.orderType,
        receive: this.receive,
        businessType: this.businessType,
      };
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/v2/order/manage/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    typeChange() {
      this.orderType = this.orderType == "" ? 1 : this.orderType == 1 ? 2 : 1;
      this.receive = "";
      this.businessType = "";
      this.getOrderList();
    },
    receiveChange() {
      this.receive = this.receive == "" ? 1 : this.receive == 1 ? 2 : 1;
      this.orderType = "";
      this.businessType = "";
      this.getOrderList();
    },
    businessChange() {
      this.businessType =
        this.businessType == "" ? 1 : this.businessType == 1 ? 2 : 1;
      this.orderType = "";
      this.receive = "";
      this.getOrderList();
    },
    query() {
      this.getOrderList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.receive = "";
      this.orderType = "";
      this.businessType = "";
      this.getOrderList();
    },
    addOrder() {
      this.$router.push("/AddOrder");
    },
    transferOrder() {
      if (this.tableVal.length > 1) {
        this.$message.warning("一次只能选择一条数据");
        return;
      }
      let id = this.$getIds(this.tableVal);
      if (!id) {
        return;
      }
      console.log(id);
      this.$router.push("/TransferOrder/" + id);
    },
    async delOrder() {
      let _this = this;
      //多选删除
      let ids = _this.$getIds(_this.tableVal);
      if (!ids) {
        return;
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete(
            "/api/v2/order/manage",
            {
              data: JSON.stringify(ids),
            }
          );
          if (res.code == 1) {
            _this.$message.success("操作成功");
            let totalPage = Math.ceil((_this.total - 1) / 10);
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage;
            _this.currentPage = currentPage < 1 ? 1 : currentPage;
            _this.getOrderList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    handleClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getOrderList();
    },
    //列表详情弹窗内容
    async getOrderInfo(rowData) {
      console.log(rowData);
      let id = rowData.id;
      this.step = [];
      //显示弹框
      this.infoVisible = true;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/info/" + id
      );
      if (res.code == 1) {
        this.infoData = res.data;
        this.orderInfoData = res.data.schedules;
        this.detailsInfoData = res.data.details;
        this.stationInfoData = res.data.station;
        this.detailsInfoData.receiveState =
          this.detailsInfoData.receiveState == "1"
            ? "待接单"
            : this.detailsInfoData.receiveState == "2"
            ? "已接单"
            : "待转单";
        this.detailsInfoData.type =
          this.detailsInfoData.type == 1 ? "计划发电" : "应急发电";
        for (let i = 0; i < this.orderInfoData.length; i++) {
          if (this.orderInfoData[i].receiptTime) {
            this.step.push(5);
          } else if (this.orderInfoData[i].powerEndTime) {
            this.step.push(4);
          } else if (this.orderInfoData[i].powerStartTime) {
            this.step.push(3);
          } else if (this.orderInfoData[i].receiveTime) {
            this.step.push(2);
          } else if (this.orderInfoData[i].dispatchTime) {
            this.step.push(1);
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getpic(rowData) {
      this.scenePhotos = [];
      this.picFlag = false;
      let id = rowData.id;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/v2/order/manage/scene/task/" + id
      );
      if (res.code == 1) {
        if (res.data.length == 0) {
          this.picVisible = true;
          this.picFlag = true;
          return;
        }
        for (let i = 0; i < res.data.length; i++) {
          let obj = {};
          obj.urls = [];
          obj.personnelName = res.data[i].personnelName;
          obj.plateNum = res.data[i].plateNum;
          for (let j = 0; j < res.data[i].imageList.length; j++) {
            obj.urls.push(res.data[i].imageList[j].url);
          }
          this.scenePhotos.push(obj);
        }
        this.picVisible = true;
      } else {
        _this.$message.warning(res.msg);
      }
      console.log(id);
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.full-page {
  padding: 0 20px;
  background: #fff;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
//详情弹窗样式
.info-box /deep/ .el-dialog {
  width: 1200px;
}
.info-box /deep/ .el-row {
  height: 32px;
  line-height: 32px;
  padding-left: 60px;
  color: #333;
}
.info-box /deep/ .dialog-label {
  font-weight: bold;
}
.con-left {
  width: 50%;
  display: inline-block;
}
.con-right {
  width: 50%;
  display: inline-block;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.time-wrap {
  width: 180px;
  height: 56px;
  padding: 10px;
  background: #ddf0fe;
  box-sizing: border-box;
}
.time-box {
  width: 100%;
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  border: 2px solid #18232c;
  border-radius: 6px;
  display: inline-block;
  box-sizing: border-box;
}
.time-con {
  float: right;
  font-size: 18px;
  color: #0094ff;
}
.examine-dialog /deep/ {
  .dialog-title {
    width: auto;
  }
  .examine-box {
    max-height: 600px;
    overflow: auto;
    margin-bottom: 10px;
  }
  .image-box {
    padding-left: 16px;
  }
  .el-dialog {
    width: 600px;
  }
  .el-dialog__body {
    color: #333;
  }
  .el-row {
    height: 32px;
    line-height: 32px;
    .dialog-label {
      margin-left: 20px;
      font-weight: normal;
    }
  }
}
.examine-dialog /deep/ .el-form-item__label {
  width: 88px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.examine-dialog /deep/ .el-form-item__content {
  width: 380px;
  height: auto;
}
.pBox {
  height: 200px;
  p {
    font-size: 18px;
    color: #333;
  }
}
.textBox {
  width: 100%;
  height: 100px;
  p {
    font-size: 16px;
    color: #333;
  }
}
::v-deep .el-date-editor.el-input {
  width: 240px;
}
::v-deep .input-form-inline .el-form-item .el-form-item__content {
  width: 240px;
}
.modify {
  ::v-deep .el-select {
    height: 30px;
    width: 100px;

    .el-input__suffix {
      position: absolute;
      right: 0 !important;
      left: 70px;
      .el-input__icon {
        line-height: 30px;
      }
    }

    .el-input__inner {
      color: #0094ff;
      width: 98px;
      height: 30px;
      // border: none;
      padding: 0 5px;
    }
  }
}
</style>
